import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import InsertKhedmat from "./components/InsertKhedmat/InsertKhedmat";
import TblKhadmat from "./components/TblKhadamat/TblKhadmat";
import { useDispatch, useSelector } from "react-redux";
import { GetAllKhedmat } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function Khadamat() {
  const { khedmatDataPagination } = useSelector((state) => ({
    khedmatDataPagination: state.khedmat.khedmatDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: khedmatDataPagination.Limit,
          Page: khedmatDataPagination.Page,
          Name: "",
        };
        await dispatch(GetAllKhedmat(params));

        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id={"services"}/>} />
        <div className="top-buttons">
          {(read("khadamatRules").accessRegister !== false) && <InsertKhedmat />}
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TblKhadmat />
      </MuiPaper>
    </>
  );
}

export default Khadamat;
